import { ToothDataEntry, ToothSurfaceDataType } from '../teethData';
import { ToothView } from '../../../Enums/ToothView.enum';
import { ToothSurface } from '../../../../../graphql/graphql';

export const Tooth75: ToothDataEntry = {
	[ToothView.INCISAL]: {
		surfaces: {
			[ToothSurface.Occlusal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M45.1,84.9s3.2,9.4-.2,19.8c0,0,3.8-1.5,11.5-1.5s19.4,11,34.3,11,22.5-9.9,34.5-11.4,12.6.2,12.6.2c0,0-2.8-12.7-.2-19.2,0,0-8.7.9-16.1.9s-18.7-9-31.2-9-21.3,10.3-30.9,10.3-14.2-1.2-14.2-1.2Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M9.2,71.5l-1.2,7.6-.6,7.4-.5,11.1v7.8l.6,9.4,2.2,8s21.2-15.1,35.4-18c0,0,3.4-9.2.2-19.8,0,0-28.4-5.4-36-13.4Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M168.2,65.5l2.6,3.1,2.1,5.7,1.6,4.3.9,5.2v8.4c-.1,0,.1,18.3.1,18.3l-.5,11.2s-23.7-16.7-37.1-18.7c0,0-2.8-12.1-.2-19.2,0,0,27.8-11.7,30.5-18.3Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M90.3,75.8s8.6-48.3-1.6-48.3-24.3.2-24.3.2l-9.3,1.4-8.8,2.3-7.3,2.7-6.2,3.8-6.1,5-7,7.4-4.9,5.9-3.5,7.3-1.8,4.9-.5,3.3s16.3,14.9,50.2,14.6c14.2-.2,16.5-10.3,30.9-10.3Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M88.7,27.4l29.3.3,8.8,1.7,7.1,2.1,6.4,2.7,4.1,1.5,3.3,2.7,4.2,3.2,3.9,3.8,4.6,4.9,2.3,3.8,3.2,4.7,2.2,6.7s-2.1,7.1-30.5,18.3c0,0-8.8,1.6-16.1.9-12.1-1.1-9.4-5.8-31.2-9,0,0,8.4-47.4-1.6-48.3Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M94.1,114.1s10.3,17.7-1.1,52.9l-8.6-2.9-9.3.2-17.1-.8-10.6-3.1-6.6-2-6.7-3.5-6.7-5-5.4-4.7-4.6-6.4-3.4-5.2-2.3-6-2.2-4.8s22.5-16,35.4-18c0,0,4-1.5,11.5-1.5s18.8,12,37.7,10.9Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M174.9,121.7v6.4c0,0-.7,6-.7,6l-1.8,4.7-5,4.5-3.8,2.9-4.7,1.7-3.7,1.7-2.7,2-4.1,3.6-5.6,4.5-4.6,2.8-5.6,2.8-6.3,2.4-5.5,1.4-5.2.9h-12.4c0,.1-6.4-1-6.4-1l-3.8-1.9c11.2-36.2,1.1-52.9,1.1-52.9,12.2-1.3,19.8-9.6,31.1-11.3,0,0,6.8-1,12.6.2,0,0,10.5.3,37.1,18.7Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M145.8,155.3c-16.2,14.9-39.4,17-59.9,9.6-10.1-3.6-24.7.8-44.9-7.2S9,130.5,7.4,110s.2-28.1,2.7-41.9,6.6-14.7,12.2-20.8c11.2-12.2,25.7-18.6,42.4-19.5,15.4-.9,30.6-1,46.3-.5,8.9.2,17,2.7,25.3,5.6,12.7,4.4,22.2,13.8,28.4,25.5s7,12.2,8.5,19.3,1.4,18.7,1.6,28.4c.2,10.5.5,20.8-3.3,30.7-3.4,8.8-16.2,10-25.7,18.6Z',
			},
		},
	},
	[ToothView.LINGUAL]: {
		surfaces: {
			[ToothSurface.Lingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M99.3,400.6A7.6,7.6 0 1 0 84.1,400.6A7.6,7.6 0 1 0 99.3,400.6Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M45.7,450.8s.6-27.8.6-34.3-1.8-9.8-9.8-9.8-26.9,0-26.9,0v3.4c-.1,0,.4,3.1.4,3.1l1,4.2,2.2,7.3,2.1,3.7,4.1,4.7,5.7,5.6,4.5,4.5,3.4,3.2,4.3,3,2.2,1.3h6.2Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M166.4,393.1l1.3,4.4,1.1,4.8.6,4.3-.6,6.4-.5,3.3-2.5,6.5-5.4,8.1-5.5,8.4-7.7,9.1-8.4,6.4-3.8,2.3v-52.9c0-6,2.9-10.4,9.3-10.4s22.2-.6,22.2-.6Z',
			},
			[ToothSurface.CervicalLingual]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M22,370.8s59.2-13.1,133.2,0l-3.4-7.4s-70.1-18.7-126.6,0l-3.2,7.4Z',
			},
			[ToothSurface.MesioLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M92.8,439.6l-3.8-2.7h-2.5c0,0-13,5-13,5l-11,3.8-8.8,4.9h-14.1l-3.7-2.3-3.7-2.9-5.4-5.2-5.9-5.7-5.8-6.4-1.7-3.4-2.3-7.5-1.4-7.1v-3.4c.1,0-.2-10.6-.2-10.6l1.4-6.2,2.4-5.6,2.8-4.5,3.3-4.9,2.7-4.1s29.5-6.5,65.8-5.8c0,0,8.4,36.3,5,74.6Z',
			},
			[ToothSurface.DistoLingualCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M155.2,370.8l3.6,5.5,3.2,6,2.9,6.2,1,3,.4,1.5,3.1,12.3-1.2,10.9-2.6,7.1-8.1,12-5.8,8.2-4.6,4.9-12.2,8.6h-10.6c0,0-9.5-5.7-9.8-5.7s-8.8-2.7-8.8-2.7l-5.9-2.5-5.1-4.2-2-2.1s3.8-32.5-5-74.6c0,0,27.7-1.1,67.4,5.8Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M62.8,445.6c-7.3,4.4-17.9,8.4-25.7,3.1-7.9-5.4-15.6-12.6-21.2-20.6-5.9-8.3-6.8-20-6.3-29.8s5.4-15.3,9.5-22.2l3.7-6.4c12,11.6,23,22,39.2,21.3,14.8-.7,46.6-1.7,53.3-7.7,9.2-8.1,17.6-16.4,27.8-23.2,2.4-1.6,4.7-3.1,7.6-3,.3,2.7.7,5.1,1.8,7.4l12.9,26.1,2.7,12.2c2,9.2-1,16.4-5.5,23.7s-12.5,19.7-22.3,26.8c-13,9.4-19.5-.9-32.1-4.4s-12.6-6.9-18.5-11.6c-2.5-1.3-6.7,1.6-8.9,2.4-6.2,2.2-11.8,2.3-17.9,6Z',
			},
		},
	},
	[ToothView.BUCCAL]: {
		surfaces: {
			[ToothSurface.Buccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M102.2,108.8A10.5,10.5 0 1 0 81.2,108.8A10.5,10.5 0 1 0 102.2,108.8Z',
			},
			[ToothSurface.Mesial]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41.6,57l-8.2-2.7h-2.8c0,.1-3.5.9-3.5.9l-5,4.3-7.2,7.4-5,5.5-2.8,10.2-1.1,10.5v6.4c.1,0,1.6,4,1.6,4,0,0,20.2-.1,24-.1s10.4-5.3,10.4-14.2-.1-32.1-.1-32.1Z',
			},
			[ToothSurface.Distal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M137.7,57.8l8.7,5.7,5.5-3,8.7-1.4,6.8,1.8,4.3,4.3,3.3,6.2,2.8,6.5,2.6,9.5v5.8l-2,7.7-1.4,3.7h-28s-11.4-1.4-11.4-13.6.1-33.2.1-33.2Z',
			},
			[ToothSurface.CervicalBuccal]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M17.7,119.8s72.2,41.2,151.8,0l-6.5,13.7s-58.3,39.2-141.1,0l-4.2-13.7Z',
			},
			[ToothSurface.MesioBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M85.8,63.5l-4.2,2.8-3.5.8h-3.5c0-.1-3.2-2-3.2-2l-10.5-4.2-8.6-2.2-11.8-2.5-5.2-1.8h-1.9s-6.4.8-6.4.8l-17.2,17.2-3.1,10.8-.8,14.1v2.2c.1,0,1.3,4.2,1.3,4.2l4.4,6.9,2.8,4.3,1.8,3.2,1.5,1.7s31.3,17.8,73.8,18.3c0,0,4.7-47.9-5.6-74.6Z',
			},
			[ToothSurface.DistoBuccalCusp]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M85.8,63.5l4.3-2.8,6.9-5,6.4-3.1,3.2-1.3,13-.2,6.3,1.4,9.2,3.6,2.6,1.6,8.7,5.7,5.5-3,8.7-1.4,6.8,1.8,4.3,4.3,3.4,6.6,2.7,6,.4,1.7,1.9,6.8.2,4.2-.2,3.3-1.1,4.8-1.2,3.8-1.2,3.9-2.8,6.6-4.2,6.8s-33,19.4-78,18.3c0,0,4.9-43.6-5.6-74.6Z',
			},
			[ToothSurface.Crown]: {
				type: ToothSurfaceDataType.PATH,
				data: 'M41,133.6c-12.8-3.2-21.2-10.7-27.9-20.6s-8.1-16.6-6.4-27.1,4.4-16.1,11.8-22.5,8.5-10.1,15.3-8.4l15.5,4c7.1,1.8,13.5,2.6,20,6.1s6.3,3.3,9.2,2.6c9.4-2,20.1-15.7,31.5-16.3,13.4-.6,25.7,4.6,36.3,12.7,4.5-1.9,8.7-4.6,13.8-4.7,12-.4,18.2,17.6,19.4,30.7-1.1,15.2-7.5,26.7-14.9,39.9-38.4,6.3-85.8,13.2-123.7,3.7Z',
			},
		},
	},
};
